import axios from "./_axios";
import { API } from "./apiEndPoints";

function nameAvailabilityUrl(accountId, type) {
  return `${API.ACCOUNT_LIST_V2}${accountId}/${type}/${API.NAME_AVAILABILITY}`;
}

/**
 * GET /api/common/v2/account/<accountId>/<type>/name-availability/
 *
 * Live uniqueness check for an org-object name (Role, Responsibility, Department,
 * Job Family, Job Family Level, Job Category). The backend is the source of truth:
 * it compares case-insensitively and always receives `exclude_id` so the object's
 * own name (in any case) is never reported as taken.
 *
 * Resolves on a 200 with `{ available, normalized_name, code }` — `available` is
 * `false` (and `code` is the object's `<OBJECT>_DUPLICATE_NAME`) when the name is
 * already taken; `code` is `null` for a blank name, which nothing collided with.
 */
export const checkOrgObjectNameAvailability = ({
  accountId,
  type,
  name,
  excludeId,
  jobFamilyId,
}) => {
  const params = {
    name: name != null ? String(name).trim() : "",
  };
  if (excludeId !== undefined && excludeId !== null && excludeId !== "") {
    params.exclude_id = excludeId;
  }
  if (jobFamilyId !== undefined && jobFamilyId !== null && jobFamilyId !== "") {
    params.job_family_id = jobFamilyId;
  }
  return axios()({ method: "get", url: nameAvailabilityUrl(accountId, type), params });
};
